import { Link } from "react-router-dom";
import { getCategory } from "@/mocks/categories";
import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  const cat = getCategory(comic.category);
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} ${comic.short}`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2.5 top-2.5 rounded-full px-2.5 py-1 text-xs font-medium text-background-50 ${
            comic.status === "连载中" ? "bg-accent-500" : "bg-foreground-900/80"
          }`}
        >
          {comic.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center justify-between bg-gradient-to-t from-foreground-950/70 to-transparent px-2.5 pb-2 pt-8 text-xs text-background-50">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {comic.views}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-book-open-line" />
            {comic.chapters} 话
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col gap-1.5 p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">{comic.title}</h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500">{comic.short}</p>
        <div className="mt-auto flex items-center justify-between pt-1">
          <span className="text-xs text-foreground-400">{cat?.name}</span>
          <span className="flex items-center gap-1 text-xs font-medium text-accent-600">
            <i className="ri-star-fill text-accent-500" />
            {comic.rating.toFixed(1)}
          </span>
        </div>
      </div>
    </Link>
  );
}